import { Grid, Typography } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { If } from '../../common/IfComponent';
import { RootState } from '../../store';
import ExternalPriceButtons from './ExternalPriceButtons';
import { ExternalPricelistDialog } from './ExternalPricelistDialog';
import ExternalPriceTable from './ExternalPriceTable';
import { getSelectedExternalPricelistIds } from './redux/externalPriceSelectors';
import {
    closeChooseExternalPricelistsDialog,
    externalPriceTablePricelistsSelected
} from './redux/externalPriceSlices';

const mapStateToProps = (state: RootState) => ({
    selectedExternalPricelistId: state.externalPrice.selectedExternalPricelistIds,
    isSelectPriceDialogOpen: state.externalPrice.ui.externalPricelistDialog,
    selectedExtPricelistIds: getSelectedExternalPricelistIds(state)
});
export type ExternalPricelistTreeProps = {
    onExternalPricelistSelected?: (externalPricelistId: number) => void;
};
type Props = ReturnType<typeof mapStateToProps> & ExternalPricelistTreeProps;

const ExternalPrice = ({
    selectedExternalPricelistId,
    isSelectPriceDialogOpen,
    selectedExtPricelistIds
}: Props) => {
    const dispatch = useDispatch();

    const closeDialog = () => {
        dispatch(closeChooseExternalPricelistsDialog());
    };
    const setSelectedExternalPricelistId = (refs: number[]) => {
        dispatch(externalPriceTablePricelistsSelected(refs!));
    };
    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ExternalPriceButtons />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="subtitle1">
                        {selectedExternalPricelistId.length === 0
                            ? 'Choose pricelists first in order to change prices'
                            : ''}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <ExternalPriceTable />
                </Grid>
                <If
                    condition={isSelectPriceDialogOpen.isChooseExternalPricelistsDialogOpen}
                    then={
                        <ExternalPricelistDialog
                            selectedExtPricelistIds={selectedExtPricelistIds}
                            multiSelect={true}
                            handleExternalPricelistSelected={setSelectedExternalPricelistId}
                            handleClose={closeDialog}
                        />
                    }
                    else={null}
                />
            </Grid>
        </>
    );
};

export default connect(mapStateToProps)(ExternalPrice);
